import ArrondissementPage from "../ArrondissementPage";
import { arrondissementsData } from "@/mocks/arrondissements";

export default function ParisArrEstPage() {
  const data = arrondissementsData.find((a) => a.slug === "est")!;
  return <ArrondissementPage data={data} />;
}
